import { Link } from 'react-router-dom';

interface Video {
  id: number;
  title: string;
  category: string;
  cover: string;
  duration: string;
  views: number;
  rating: number;
  description: string;
  tags: string[];
  featured?: boolean;
}

interface VideoCardProps {
  video: Video;
  featured?: boolean;
}

function formatViews(views: number): string {
  if (views >= 100000000) return `${(views / 100000000).toFixed(1)}亿`;
  if (views >= 10000) return `${(views / 10000).toFixed(0)}万`;
  return views.toLocaleString();
}

export default function VideoCard({ video, featured }: VideoCardProps) {
  return (
    <article className="group cursor-pointer" data-product-shop="">
      <div className={`relative overflow-hidden rounded-lg mb-3 ${
        featured ? 'aspect-[16/7]' : 'aspect-video'
      }`}>
        <img
          src={video.cover}
          alt={video.title}
          title={`${video.title} - 爱液视频高清在线观看`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
        <div className="absolute top-3 left-3">
          <span className="bg-primary-500/90 text-background-50 text-xs px-2.5 py-1 rounded-full font-medium">
            {video.rating}
          </span>
        </div>
        <div className="absolute bottom-3 right-3">
          <span className="bg-black/70 text-background-50 text-xs px-2 py-0.5 rounded">
            {video.duration}
          </span>
        </div>
        <div className="absolute bottom-3 left-3 flex items-center gap-1.5 text-background-50/90 text-xs">
          <i className="ri-eye-line"></i>
          <span>{formatViews(video.views)}</span>
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-2xl ml-0.5"></i>
          </div>
        </div>

        {featured && (
          <div className="absolute top-3 right-3">
            <span className="bg-accent-500/90 text-background-50 text-xs px-2.5 py-1 rounded-full font-medium flex items-center gap-1">
              <i className="ri-fire-line"></i> 热门
            </span>
          </div>
        )}
      </div>

      <h3 className={`font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 ${
        featured ? 'text-lg' : 'text-sm'
      }`}>
        {video.title}
      </h3>

      <p className={`text-foreground-500 line-clamp-1 mt-1 ${
        featured ? 'text-sm' : 'text-xs'
      }`}>
        {video.description}
      </p>

      <div className="flex items-center gap-1.5 mt-2 flex-wrap">
        {video.tags.map((tag) => (
          <span key={tag} className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
            {tag}
          </span>
        ))}
      </div>
    </article>
  );
}